export function isNumber(value:any){
    if(isNaN(parseInt(value))) return 'Must be a number';
}
